var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_user-agent.js
// module id = 805
// module chunks = 0